/* eslint-disable react/prop-types */
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import LoadingButton from "@mui/lab/LoadingButton";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import "react-quill/dist/quill.snow.css";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { questService } from "services/questService";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
import CardFooter from "../../components/Card/CardFooter";
import Button from "../../components/CustomButtons/Button";
import Datetime from "react-datetime";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import { collectionService } from "services/collectionService";
import { Add, Delete } from "@material-ui/icons";
import Select from "components/Select/Select";
import { chainOptions } from "const";
const useStyles = makeStyles(styles);
const useStylesDay = makeStyles(() => ({
  dateField: {
    paddingTop: "29px",
  },
}));
export default function QuestCreate() {
  const {
    register: quest,
    handleSubmit,
    control,
  } = useForm({
    defaultValues: async () => await getFormDefaultValues(id),
  });

  const target = useWatch({
    control,
    name: "target",
  });

  const type = useWatch({
    control,
    name: "type",
  });

  // eslint-disable-next-line no-unused-vars
  const {
    fields: rewardByRanks,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "rewardByRanks",
  });

  const history = useHistory();
  const [loading, setLoading] = React.useState(false);

  const { id } = useParams();
  const [endTime, setEndTime] = React.useState();

  const [limitType, setLimitType] = React.useState("maxUser");

  const [collections, setCollections] = React.useState([]);
  const collectionLoading = collections.length === 0;

  const handleEndTimeChange = (event) => {
    setEndTime(event._d);
  };

  async function createQuest(payload) {
    setLoading(true);
    try {
      const { data } = await questService.create(payload);
      toast.success("Created Quest");
      console.log(data);
      window.setTimeout(() => history.push("/admin/quest/"), 2000);
    } catch (e) {
      console.log(e);
      if (e?.message[0].length > 2) {
        toast.error(e?.message[0]);
      }
    } finally {
      setLoading(false);
    }
  }

  async function updateQuest(payload) {
    setLoading(true);

    try {
      const { data } = await questService.update(id, payload);
      console.log(data);
      toast.success("Updated Quest");
      window.setTimeout(() => history.push("/admin/quest/"), 2000);
    } catch (e) {
      console.log(e);
      if (e?.message[0].length > 2) {
        toast.error(e?.message[0]);
      }
    } finally {
      setLoading(false);
    }
  }

  async function onSubmit(form) {
    try {
      const payload = { ...form };

      if (type === "sweep") {
        if (limitType === "maxUser") {
          toast.error("Sweep need end time");
          return;
        }

        if (rewardByRanks.length === 0) {
          toast.error("Sweep need reward config");
          return;
        }
      }

      if (endTime && ["endTime", "both"].includes(limitType)) {
        payload.endTime = endTime;
      } else {
        payload.endTime = null;
      }

      if (limitType === "endTime") {
        payload.maxUsers = null;
      }

      if (target !== "collection") {
        delete payload.collection;
      }

      if (type !== "sweep") {
        delete payload.rewardByRanks;
        delete payload.sweepBy;
      }

      if (id) {
        updateQuest(payload);
      } else {
        createQuest(payload);
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message[0] || "Something went wrong");
    }
  }

  async function getFormDefaultValues(id) {
    if (!id)
      return {
        target: "marketplace",
        type: "once",
      };

    const { data } = await questService.view(id);

    const dateObject = new Date(data.endTime || Date.now());

    dateObject.setHours(dateObject.getHours());

    setEndTime(dateObject);

    if (data.maxUsers && data.endTime) {
      setLimitType("both");
    } else if (data.maxUsers) {
      setLimitType("maxUser");
    } else if (data.endTime) {
      setLimitType("endTime");
    }

    return data;
  }

  const classes = useStyles();
  const classesDay = useStylesDay();

  React.useEffect(() => {
    let active = true;

    if (!collectionLoading) {
      return undefined;
    }

    (async () => {
      const { data } = await collectionService.list({
        page: 0,
        size: 900,
      });

      if (active) {
        setCollections(
          data.items.map((item) => ({
            address: item?.address,
            name: item?.name,
            image: item?.image,
            chainId: item?.chainId,
          }))
        );
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return (
    <Card>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CardHeader color="rose" icon>
          <CardIcon color="rose">
            <Contacts />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            {id ? "Edit quest" : "Create quest"}
          </h4>
        </CardHeader>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <CardBody>
              <h3>Type</h3>

              <GridContainer alignItems="center">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Quest type
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <Controller
                    control={control}
                    name="type"
                    render={({ field: { value, onChange } }) => (
                      <Select
                        label=""
                        onChange={onChange}
                        value={value || "once"}
                        options={[
                          { value: "once", label: "Once" },
                          { value: "repeat", label: "Repeat" },
                          { value: "sweep", label: "Sweep" },
                        ]}
                      />
                    )}
                  />
                </GridItem>

                {type === "sweep" && (
                  <GridItem xs={12} sm={12} md={5}>
                    <Controller
                      control={control}
                      name="sweepBy"
                      render={({ field: { value, onChange } }) => (
                        <Select
                          label=""
                          onChange={onChange}
                          value={value || "once"}
                          options={[
                            {
                              value: "saleVolume",
                              label: "Top CRO Sell Volume",
                            },
                            { value: "buyVolume", label: "Top CRO Buy Volume" },
                            { value: "numberOfListings", label: "Top Listing" },
                            {
                              value: "numberOfPurchases",
                              label: "Top NFT Buy Count",
                            },
                            {
                              value: "numberOfSales",
                              label: "Top NFT Sell Count",
                            },
                          ]}
                        />
                      )}
                    />
                  </GridItem>
                )}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <FormLabel className={classes.labelHorizontal}>
                      Chain
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Controller
                      control={control}
                      name="chainId"
                      render={({ field: { value, onChange } }) => (
                        <Select
                          name="chainId"
                          label=" "
                          onChange={onChange}
                          value={value ?? "25"}
                          options={chainOptions()}
                        />
                      )}
                    />
                  </GridItem>
                </GridContainer>
              </GridContainer>

              <GridContainer alignItems="center">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Target
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <Controller
                    control={control}
                    name="target"
                    render={({ field: { value, onChange } }) => (
                      <Select
                        label=""
                        onChange={onChange}
                        value={value || "marketplace"}
                        options={[
                          { value: "marketplace", label: "Marketplace" },
                          { value: "collection", label: "Collection" },
                        ]}
                      />
                    )}
                  />
                </GridItem>

                {target === "collection" && (
                  <GridItem xs={12} sm={12} md={5}>
                    <ControlledAutocomplete
                      control={control}
                      loading={collectionLoading}
                      name="targetCollection"
                      options={collections}
                      getOptionLabel={(option) => `Option: ${option.name}`}
                    />
                  </GridItem>
                )}
              </GridContainer>

              <h3>Reward</h3>
              <GridContainer alignItems="flex-start">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Reward coin
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      autoComplete: "off",
                    }}
                    inputProps={{
                      type: "text",
                      autoComplete: "nope",
                      ...quest("rewardCoin"),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer alignItems="flex-start">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Reward coin symbol
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      autoComplete: "off",
                    }}
                    inputProps={{
                      type: "text",
                      autoComplete: "nope",
                      ...quest("rewardCoinSymbol"),
                    }}
                  />
                </GridItem>
              </GridContainer>

              {type !== "sweep" ? (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <FormLabel className={classes.labelHorizontal}>
                      Reward per user
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={9}>
                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        step: 0.0001,
                        type: "number",
                        autoComplete: "off",
                        ...quest("rewardPerUser"),
                      }}
                    />
                  </GridItem>
                </GridContainer>
              ) : (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <FormLabel className={classes.labelHorizontal}>
                      Reward by ranks
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={9}>
                    <Button
                      justIcon={true}
                      color="success"
                      size="sm"
                      onClick={() => {
                        append(0);
                      }}
                    >
                      <Add />
                    </Button>
                  </GridItem>
                </GridContainer>
              )}

              {type === "sweep" &&
                rewardByRanks.map((_, index) => (
                  <GridContainer alignItems="center" key={index}>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Rank {index + 1}
                      </FormLabel>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={8}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          step: 0.0001,
                          ...quest(`rewardByRanks[${index}]`, {
                            valueAsNumber: true,
                          }),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={1}>
                      <Button
                        justIcon={true}
                        color="danger"
                        size="sm"
                        onClick={() => {
                          remove(index);
                        }}
                      >
                        <Delete />
                      </Button>
                    </GridItem>
                  </GridContainer>
                ))}

              <h3>Limit</h3>

              <GridContainer alignItems="center">
                <GridItem xs={12} sm={12} md={3}>
                  <FormLabel className={classes.labelHorizontal}>
                    Select Condition
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                  <Select
                    label=""
                    value={limitType}
                    onChange={(value) => setLimitType(value)}
                    options={[
                      { value: "maxUser", label: "Max User" },
                      { value: "endTime", label: "End Time" },
                      { value: "both", label: "Both" },
                    ]}
                  />
                </GridItem>
              </GridContainer>

              {limitType === "maxUser" || limitType === "both" ? (
                <GridContainer alignItems="flex-start">
                  <GridItem xs={12} sm={12} md={3}>
                    <FormLabel className={classes.labelHorizontal}>
                      Max User
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={9}>
                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        ...quest("maxUsers"),
                      }}
                    />
                  </GridItem>
                </GridContainer>
              ) : null}

              {limitType === "endTime" || limitType === "both" ? (
                <GridContainer alignItems="flex-start">
                  <GridItem xs={12} sm={12} md={3}>
                    <FormLabel className={classes.labelHorizontal}>
                      End Time
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={9}>
                    <Datetime
                      inputProps={{ placeholder: "dd/mm/yyyy hh:mm" }}
                      dateFormat="DD/MM/YYYY"
                      value={endTime}
                      onChange={(e) => handleEndTimeChange(e)}
                      className={classesDay.dateField}
                    />
                  </GridItem>
                </GridContainer>
              ) : null}

              {type !== "sweep" && (
                <>
                  <h3>Requirement</h3>
                  <GridContainer alignItems="flex-start">
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Sale volume
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          min: 0,
                          step: 0.00001,
                          ...quest("requirement.saleVolume"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer alignItems="flex-start">
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Buy volume
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          min: 0,
                          step: 0.00001,
                          ...quest("requirement.buyVolume"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer alignItems="flex-start">
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Number of listings
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          ...quest("requirement.numberOfListings"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer alignItems="flex-start">
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Number of Sale NFT
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          ...quest("requirement.numberOfSales"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer alignItems="flex-start">
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Number of Buy NFT
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "number",
                          ...quest("requirement.numberOfPurchases"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </>
              )}
            </CardBody>

            <CardFooter>
              <GridContainer justify="flex-end">
                <GridItem xs={12} sm={6} md={6}>
                  <Button onClick={() => history.goBack()}>Cancel</Button>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <LoadingButton
                    type="submit"
                    loading={loading}
                    variant="outlined"
                  >
                    Submit
                  </LoadingButton>
                </GridItem>
              </GridContainer>
            </CardFooter>
          </GridItem>
        </GridContainer>
      </form>
    </Card>
  );
}

// eslint-disable-next-line react/prop-types
const ControlledAutocomplete = ({
  options = [],
  getOptionLabel,
  control,
  defaultValue,
  name,
  renderOption,
  ...props
}) => {
  return (
    <Controller
      onChange={([, data]) => data}
      defaultValue={defaultValue}
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          options={options}
          getOptionLabel={getOptionLabel}
          renderOption={renderOption}
          renderInput={(params) => <TextField {...params} margin="normal" />}
          isOptionEqualToValue={(option, value) =>
            option.address === value.address
          }
          onChange={(e, data) => onChange(data)}
          value={value}
          {...props}
        />
      )}
    />
  );
};
